var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "succss-modal",
      attrs: { visible: _vm.dialogVisible, width: "400px", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", [
          _c("i", { staticClass: "icon-submit" }),
          _c("span", { staticClass: "submit-text" }, [
            _vm._v(_vm._s(_vm.$t("data.successfully_submit"))),
          ]),
        ]),
        _c("p", { staticClass: "amount-text" }, [
          _vm._v(
            _vm._s(
              _vm.$t("data.cash_out") + " " + _vm.$t("components.amount")
            ) + "："
          ),
          _c("span", { staticStyle: { color: "#3855F1" } }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(_vm._f("numWithDot")(_vm.amount))
            ),
          ]),
        ]),
        _c("div", { staticClass: "line" }),
        _c("p", { staticClass: "tip" }, [
          _vm._v(_vm._s(_vm.$t("data.withdraw_success_tip"))),
        ]),
        _c(
          "div",
          {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          },
          [
            _c(
              "el-button",
              {
                staticClass: "btn-back",
                attrs: { type: "info" },
                on: {
                  click: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("components.close")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }